import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "./TopBar";

export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <div className="mx-auto flex min-h-screen max-w-app flex-col bg-white">
      <header className="safe-top sticky top-0 z-30 border-b border-slate-100 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-2">
            <LogoMark className="h-7 w-7 object-contain rounded-md" />
            <span className="text-[15px] font-bold tracking-tight text-navy sm:text-base">personaw</span>
          </Link>
          <nav className="flex items-center gap-4 text-xs font-medium text-slate-500 sm:gap-6 sm:text-sm">
            <Link to="/pricing" className="transition hover:text-navy">Pricing</Link>
            <Link
              to="/login"
              className="rounded-full bg-navy px-4 py-1.5 text-xs font-semibold text-white transition hover:bg-navy-light sm:px-5 sm:py-2 sm:text-sm"
            >
              Get Started
            </Link>
          </nav>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="safe-bottom border-t border-slate-100 bg-slate-50">
        <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <div className="flex items-center gap-2">
                <LogoMark className="h-5 w-5 object-contain rounded" />
                <span className="text-sm font-bold text-navy">personaw</span>
              </div>
              <p className="mt-2 text-[11px] leading-relaxed text-slate-400 sm:text-xs">
                © 2025 personaw.com · All rights reserved.
              </p>
            </div>
            <div className="flex gap-4 text-[11px] text-slate-400 sm:text-xs">
              <Link to="/terms" className="transition hover:text-slate-600">Terms of Service</Link>
              <Link to="/privacy" className="transition hover:text-slate-600">Privacy Policy</Link>
              <Link to="/pricing" className="transition hover:text-slate-600">Pricing</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
